import { render, staticRenderFns } from "./tableActions.vue?vue&type=template&id=3ae8d1ca&scoped=true&"
import script from "./tableActions.vue?vue&type=script&lang=js&"
export * from "./tableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8d1ca",
  null
  
)

export default component.exports